import React from 'react';
import UserIcon from '../components/icons/UserIcon';
import BoxIcon from '../components/icons/BoxIcon';
import FlagIcon from '../components/icons/FlagIcon';
import TruckIcon from '../components/icons/TruckIcon';
import CardIcon from '../components/icons/CardIcon';
import GearIcon from '../components/icons/GearIcon';
import paths from './paths';
import ReportIcon from '../components/icons/ReportIcon';
import HomeIcon from 'components/icons/HomeIcon';

const nav = [
  {
    name: 'Home',
    path: paths.getDashboardLayout,
    Icon: <HomeIcon />,
    role: 'admin',
  },
  {
    name: 'Customer',
    path: paths.customers,
    Icon: <UserIcon />,
    checkname: 'customer',
  },
  {
    name: 'Product',
    path: paths.getProductLayout,
    Icon: <BoxIcon />,
    checkname: 'products',
  },
  {
    name: 'Campaign',
    path: paths.getCampaignLayout,
    Icon: <FlagIcon />,
    checkname: 'campaigns',
  },
  {
    name: 'Orders',
    path: paths.getOrderLayout,
    Icon: <TruckIcon />,
    checkname: 'orders',
    subNav: [
      {
        name: 'Orders',
        path: paths.orders,
        checkname: 'orders.order.read',
      },
      {
        name: 'Fulfillments',
        path: paths.orderFulfilments,
        checkname: 'orders.fulfillment.read',
      },
      {
        name: 'Clicks',
        path: paths.clicks,
        checkname: 'orders.click.read',
      },
      {
        name: 'Batch Updates',
        path: paths.batchUpdates,
        checkname: 'orders.auto_rerun.read',
        subNav: [
          {
            name: 'Create Batch',
            path: paths.batchInitials,
            checkname: 'orders.auto_rerun.write',
          },
          {
            name: 'Batch Results',
            path: paths.autoReruns,
            checkname: 'orders.auto_rerun.read',
          },
        ],
      },

      {
        name: 'Transactions',
        path: paths.transactions,
        checkname: 'orders.transactions.read',
      },
      {
        name: 'Test Orders',
        path: paths.testOrders,
        checkname: 'orders.order.read',
      },
    ],
  },
  {
    name: 'Payments',
    path: paths.getPaymentLayout,
    Icon: <CardIcon />,
    checkname: 'payments',
    subNav: [
      {
        name: 'Merchant Accounts',
        path: paths.merchantAccounts,
        checkname: 'payments.gateway.read',
      },
      {
        name: 'Corporations',
        path: paths.corporations,
        checkname: 'payments.corporation.read',
      },
      {
        name: 'Banks',
        path: paths.banks,
        checkname: 'payments.bank.read',
      },
      {
        name: 'Pools',
        path: paths.pools,
        checkname: 'payments.pool.read',
      },
      {
        name: 'BIN Routings',
        path: paths.binRoutings,
        checkname: 'payments.bin_routing.read',
      },
      {
        name: 'Payment Routing',
        path: paths.merchantProfiles,
        checkname: 'payments.gateway_profile.read',
      },
      {
        name: 'Reprocessing',
        path: paths.retries,
        checkname: 'payments.settings.read',
      },
    ],
  },
  {
    name: 'Reports',
    Icon: <ReportIcon />,
    path: paths.getReportLayout,
    checkname: 'reports',
    subNav: [
      {
        name: 'Sales Pace Reports',
        path: paths.salesPaceReports,
        checkname: 'reports.sales_pace_reports.read',
        role: 'admin',
      },
      // {
      //   name: 'Sales Pace Report Line Chart',
      //   path: paths.salesPaceReportLineChart,
      //   checkname: 'reports.sales_pace_report_line_chart.read',
      //   role: 'admin',
      // },
      {
        name: 'Sales Performance Report',
        path: paths.salesPerformanceReport,
        checkname: 'reports.sales_performance_report.read',
        role: 'admin',
      },
      {
        name: 'Sales Performance Report Line Chart',
        path: paths.salesPerformanceReportLineChart,
        checkname: 'reports.sales_performance_report_line_chart.read',
        role: 'admin',
      },
      {
        name: 'Transaction Performance Report',
        path: paths.transactionPerformanceReport,
        checkname: 'reports.transaction_performance_report.read',
        role: 'admin',
      },
      {
        name: 'Retention Report',
        path: paths.retentionReport,
        checkname: 'reports.retention_report.read',
        role: 'admin',
      },
      {
        name: 'Affiliate Sales Summary',
        path: paths.affiliateSalesSummary,
        checkname: ['reports.affiliate_sale.read', 'reports.affiliate_sales_summary.read'],
        role: ['admin', 'affiliate'],
      },
      // {
      //   name: 'Cancellation Reasons (Orders)',
      //   path: paths.cancellationReasonsOrders,
      //   checkname: 'reports.cancellation_reasons_orders.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'Cancellation Reasons (Subscriptions)',
      //   path: paths.cancellationReasonsSubscriptions,
      //   checkname: 'reports.cancellation_reasons_subscriptions.read',
      //   role: 'admin',
      // },
      {
        name: 'Forecasted Rebills Report',
        path: paths.forecastedRebillsReport,
        checkname: 'reports.forecasted_rebills_report.read',
        role: 'admin',
      },
      // {
      //   name: 'Conversion Report',
      //   path: paths.conversionReport,
      //   checkname: 'reports.conversion_report.read',
      //   role: 'admin',
      // },
      {
        name: 'Decline Response Report',
        path: paths.declineResponseReport,
        checkname: 'reports.decline_response_report.read',
        role: 'admin',
      },
      {
        name: 'BIN Routing Performance Report',
        path: paths.binRoutingPerformanceReport,
        checkname: 'reports.bin_routing_performance_report.read',
        role: 'admin',
      },
      // {
      //   name: 'Variance Report',
      //   path: paths.varianceReport,
      //   checkname: 'reports.variance_report.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'Card Processing Report',
      //   path: paths.cardProcessingReport,
      //   checkname: 'reports.card_processing_report.read',
      //   role: 'admin',
      // },
      {
        name: 'Duplicate Customer Report',
        path: paths.duplicateCustomerReport,
        checkname: 'reports.duplicate_customer_report.read',
        role: 'admin',
      },
      // {
      //   name: 'Chargeback Summary Report',
      //   path: paths.chargeBackSummaryReport,
      //   checkname: 'reports.chargeback_summary_report.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'Fraud Analysis Report',
      //   path: paths.fraudAnalysisReport,
      //   checkname: 'reports.fraud_analysis_report.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'Fulfillment Summary Report',
      //   path: paths.fulfillmentSummaryReport,
      //   checkname: 'reports.fulfillment_summary_report.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'Customer Purchase Attempts Report',
      //   path: paths.customerPurchaseAttemptsReport,
      //   checkname: 'reports.customer_purchase_attempts_report.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'Revenue Summary Report',
      //   path: paths.revenueSummaryReport,
      //   checkname: 'reports.revenue_summary_report.read',
      //   role: 'admin',
      // },
      // {
      //   name: 'DTC Populated Fields',
      //   path: paths.dtcPopulatedFields,
      //   checkname: 'reports.dtc_populated_fields.read',
      //   role: 'admin',
      // },
      {
        name: 'Cap Projections Report',
        path: paths.capProjectionsReport,
        checkname: 'reports.cap_projections_report.read',
        role: 'admin',
      },
      {
        name: 'Reprocessing Report',
        path: paths.reprocessingReport,
        checkname: 'reports.reprocessing_report.read',
        role: 'admin',
      },
      // {
      //   name: 'Products Report',
      //   path: paths.productsReport,
      //   checkname: 'reports.products_report.read',
      //   role: 'admin',
      // },
      {
        name: 'Negatives Report',
        path: paths.negativesReport,
        role: 'admin',
      },
    ],
  },
  {
    name: 'Admin',
    path: paths.getAdminLayout,
    Icon: <GearIcon />,
    checkname: 'settings',
    subNav: [
      {
        name: 'Roles',
        path: paths.roles,
        checkname: 'settings.role.read',
      },
      {
        name: 'Users',
        path: paths.users,
        checkname: 'settings.user.read',
      },
      {
        name: 'Logs',
        path: paths.logs,
        checkname: 'settings.logs.read',
      },
      {
        name: 'Whitelists',
        path: paths.whitelists,
        checkname: 'settings.white_lists.read',
      },
      {
        name: 'Blacklists',
        path: paths.blacklists,
        checkname: 'settings.black_lists.read',
      },
      {
        name: 'Plugins',
        path: paths.smtp,
        checkname: 'settings.plugins.read',
      },
      {
        name: 'Affiliate',
        path: paths.adminAffiliates,
        checkname: 'settings.affiliate.read',
      },
      {
        name: 'Test Cards',
        path: paths.testCards,
        checkname: 'settings.test_card.read',
      },
    ],
  },
];

export default nav;
